import { render, staticRenderFns } from "./button.vue?vue&type=template&id=7e584714&scoped=true&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"
import style0 from "./button.vue?vue&type=style&index=0&id=7e584714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e584714",
  null
  
)

export default component.exports